import { render } from "./Price.vue?vue&type=template&id=23600cee&scoped=true"
import script from "./Price.vue?vue&type=script&lang=ts"
export * from "./Price.vue?vue&type=script&lang=ts"

import "./Price.vue?vue&type=style&index=0&id=23600cee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23600cee"

export default script